<template>
    <div id="storeadd">
       <HeaderNav :is_dialogpage="false" :routername="this.$route.name" :addoredirtname="'0'"></HeaderNav>
       
       <div class="store-page" v-if="storeInfoLoaded">
           <!-- 顶部操作栏 -->
           <div class="store-topbar">
               <div class="store-title">
                   <h2>{{ formData.storeName }}</h2>
                   <span class="store-type-tag">{{ formData.storeTypeName }}</span>
               </div>
               <a href="javascript:void(0);" class="edit-btn" v-if="myContrArr.includes(1)" @click="openEdirt()">
                   <span class="edit-icon">&#9998;</span> 修改信息
               </a>
           </div>

           <!-- 基本信息卡片 -->
           <div class="info-card">
               <div class="card-header">
                   <span class="card-icon">&#127968;</span>
                   <h3>基本信息</h3>
               </div>
               <div class="card-body">
                   <div class="info-row">
                       <div class="info-item">
                           <span class="info-label">酒店名称</span>
                           <span class="info-value">{{ formData.storeName }}</span>
                       </div>
                       <div class="info-item">
                           <span class="info-label">酒店类型</span>
                           <span class="info-value">{{ formData.storeTypeName }}</span>
                       </div>
                   </div>
                   <div class="info-row">
                       <div class="info-item full-width">
                           <span class="info-label">酒店地址</span>
                           <span class="info-value">{{ formData.address }}</span>
                       </div>
                   </div>
                   <div class="info-row">
                       <div class="info-item">
                           <span class="info-label">联系电话</span>
                           <span class="info-value">{{ formData.storeTel }}</span>
                       </div>
                       <div class="info-item">
                           <span class="info-label">统一社会信用代码</span>
                           <span class="info-value">{{ formData.storeIcNo }}</span>
                       </div>
                   </div>
               </div>
           </div>

           <!-- 法人信息卡片 -->
           <div class="info-card">
               <div class="card-header">
                   <span class="card-icon">&#128100;</span>
                   <h3>法人信息</h3>
               </div>
               <div class="card-body">
                   <div class="info-row">
                       <div class="info-item">
                           <span class="info-label">法人姓名</span>
                           <span class="info-value">{{ formData.storeLegeName }}</span>
                       </div>
                       <div class="info-item">
                           <span class="info-label">法人手机号</span>
                           <span class="info-value">{{ formData.storeLegeMobile }}</span>
                       </div>
                   </div>
                   <div class="info-row">
                       <div class="info-item">
                           <span class="info-label">法人身份证号</span>
                           <span class="info-value">{{ formData.storeLegeIdCard }}</span>
                       </div>
                   </div>
                   <div class="info-row">
                       <div class="info-item">
                           <span class="info-label">营业执照</span>
                           <div class="info-value img-value">
                               <div class="img-card" v-if="formData.businessLicenseFront" @click="showimg(formData.businessLicenseFront)">
                                   <img :src="formData.businessLicenseFront">
                                   <div class="img-overlay">点击预览</div>
                               </div>
                               <span v-else class="no-img">暂无图片</span>
                           </div>
                       </div>
                   </div>
                   <div class="info-row">
                       <div class="info-item">
                           <span class="info-label">身份证照片</span>
                           <div class="info-value img-value id-card-row">
                               <div class="id-card-item">
                                   <span class="id-card-label">正面</span>
                                   <div class="img-card small" v-if="formData.icpicFront" @click="showimg(formData.icpicFront)">
                                       <img :src="formData.icpicFront">
                                       <div class="img-overlay">点击预览</div>
                                   </div>
                                   <span v-else class="no-img">暂无</span>
                               </div>
                               <div class="id-card-item">
                                   <span class="id-card-label">反面</span>
                                   <div class="img-card small" v-if="formData.icpicBack" @click="showimg(formData.icpicBack)">
                                       <img :src="formData.icpicBack">
                                       <div class="img-overlay">点击预览</div>
                                   </div>
                                   <span v-else class="no-img">暂无</span>
                               </div>
                           </div>
                       </div>
                   </div>
               </div>
           </div>

           <!-- 酒店详情卡片 -->
           <div class="info-card">
               <div class="card-header">
                   <span class="card-icon">&#128196;</span>
                   <h3>酒店详情</h3>
               </div>
               <div class="card-body">
                   <div class="detail-row">
                       <span class="detail-label">酒店设施</span>
                       <div class="detail-content">{{ formData.storePlan }}</div>
                   </div>
                   <div class="detail-row">
                       <span class="detail-label">服务项目</span>
                       <div class="detail-content">{{ formData.storeServer }}</div>
                   </div>
                   <div class="detail-row">
                       <span class="detail-label">预约说明</span>
                       <div class="detail-content">{{ formData.storeReservation }}</div>
                   </div>
                   <div class="detail-row">
                       <span class="detail-label">详情介绍</span>
                       <div class="detail-content rich-text" v-html="formData.storeDesc"></div>
                   </div>
               </div>
           </div>
       </div>
   </div>
  
   <div id="showimgbox" v-if="this.showimg_src" @click.self="this.closeshowimgbox">
         <a href="javascript:void(0);" @click="this.closeshowimgbox">关闭</a>
         <img :src="this.showimg_src" @load="loadimgfun" ref="imageElement" :style="{width:this.show_img_width+'px',
            height:this.show_img_height+'px',marginTop:(0-(this.show_img_height/2))+'px',marginLeft:(0-(this.show_img_width/2))+'px'}"></img>
   </div>
   <StoreInfoEdirt v-if="is_show" :is_edirt="true" @closerush="closePage(1)" @closepage="closePage(0)"></StoreInfoEdirt>
</template>

<script>
import HeaderNav from '../common/HeaderNav.vue';
import { ElMessage } from 'element-plus';
import '@wangeditor/editor/dist/css/style.css' // 引入 css
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
// 请根据实际项目 API 文件路径引入对应的接口
import { selectStoreInfo,findMenuContrByMenuId } from '@/tools/Api';

import StoreInfoEdirt from './StoreInfoEdirt.vue';


export default {
   name: "StoreAdd",
   data() {
       return {
            myMenuCode: 1, 
            myContrArr: [], 
           addoredirtname: "",
           is_show: false,
           showimg_src: "",
           show_img_width: 0,
           show_img_height: 0,
           store_id: '',
           storeInfoLoaded:false,
           storeStatus: "",
           
           // 表单数据对象
          formData: {
                storeName: "",//酒店名称
                storeIcNo: "",//社会信用码
                address: "",//酒店地址
                storeDesc: "", //酒店描述
                storeTel: "",//酒店电话
                storeLegeName:"", //法人姓名
                storeLegeIdCard: "",//法人身份证号 
                storeLegeMobile: "",//法人手机号
                storePlan:"",//酒店设施
                storeServer:"",//服务项目
                storeReservation:"",//预约说明
                businessLicenseFront: "", //营业执照
                icpicFront: "",//身份证正面
                icpicBack: "", //身份证反面
                storeType: "",//酒店类型
           }
       };
   },
   components: {
       HeaderNav,
       StoreInfoEdirt
   },
   props: {
       is_edirt: {
           type: Boolean,
           required: false
       },
    //    // 假设传入的是 storeId
    //    roleId: { 
    //        type: [Number, String],
    //        default: ""
    //    }
   },
   mounted() {
      this.btnListfind()
      this.getStoreInfo()
   },
   methods: {
     btnListfind() {
          findMenuContrByMenuId(this.myMenuCode).then(res => {
             if (res.status == 0) {
                this.myContrArr = res.data;
             } else {
                ElMessage({ message: "获取权限失败！", type: 'error', duration: 1500 });
             }
          }).catch(error => {
             ElMessage({ message: "请求失败！", type: 'error', duration: 1500 });
          });
       },
    openEdirt(){
        // if(this.storeStatus==4){ 
        //     ElMessage({
        //                message: "信息审核中，无法进行该操作！",
        //                type: 'error',
        //                duration: 1800
        //            });
        //     return
        // }
    
         this.is_show=true
    },
    closeshowimgbox(){
        this.showimg_src=""
        this.show_img_width=0
        this.show_img_height=0
    },
    closePage(op){
        if(op==1){
            this.is_show=false
            this.getStoreInfo()
        }else{
            this.is_show=false
        }
    },
    async loadimgfun(){
        
        let w=0
        let h=0
        if(w>h){ 
             this.show_img_width=600;
             this.show_img_height=Math.round(w/600*h);
        }else{
             this.show_img_height=600;
             this.show_img_width=Math.round(h/600*w);
        }
         const img = new Image()
      img.src = this.showimg_src
      await new Promise((resolve) => {
        img.onload = () => {
        
         w= img.width
         h= img.height
         if(w>h){ 
             this.show_img_width=600;
             this.show_img_height=Math.round(600/w*h);
        }else{
             this.show_img_height=600;
             this.show_img_width=Math.round(600/h*w);
        }
        console.log(this.show_img_width)
          resolve()
        }
      })
    },
    showimg(src){
        this.showimg_src=src;
    },

       // 获取详情用于编辑
       getStoreInfo() {
           selectStoreInfo(this.roleId).then(res => {
               if (res.status == 0) {
                   const data = res.data;
                   this.formData = {
                        storeName: data.storeName,//酒店名称
                        storeIcNo: data.storeIcNo,//社会信用码
                        address: data.storeAddr,//酒店地址
                        storeDesc:data.storeDesc? data.storeDesc.trim():"暂无描述", //酒店描述
                        storeTel: data.storeTel,//酒店电话
                        storeLegeName:data.storeLegeName, //法人姓名
                        storeLegeIdCard:data.storeLegeNo,//法人身份证号 
                        storeLegeMobile: data.storeLegePhone,//法人手机号
                        storePlan:data.storePlan,//酒店设施
                        storeServer:data.storeServer,//服务项目
                        storeReservation:data.storeReservation,//预约说明
                        businessLicenseFront: data.storeIcSrc, //营业执照
                        icpicFront: data.storeLegIc1Src,//身份证正面
                        icpicBack: data.storeLegIc2Src, //身份证反面
                        storeType: data.storeType,//酒店类型
                        storeTypeName: data.storeTypeName
                   };
                   this.storeInfoLoaded = true;
                   this.storeStatus=data.storeStatus
                  
               } else {
                   ElMessage({
                       message: res.msg || "获取详情失败",
                       type: 'error',
                       duration: 1500
                   });
               }
           }).catch(err => {
               ElMessage({
                   message: "请求失败！",
                   type: 'error',
                   duration: 1500
               });
           });
       },

      

    }
}
</script>

<style scoped>
#storeadd {
   width: 100%;
   height: 100%;
   position: relative;
   background-color: #f5f6f8;
   float: left;
}

/* 页面主体 */
.store-page {
   width: 100%;
   height: calc(100% - 40px);
   float: left;
   padding: 24px 40px;
   overflow-y: auto;
   box-sizing: border-box;
}

/* 顶部操作栏 */
.store-topbar {
   width: 100%;
   display: flex;
   justify-content: space-between;
   align-items: center;
   margin-bottom: 24px;
   background: #fff;
   padding: 20px 28px;
   border-radius: 10px;
   box-shadow: 0 2px 12px rgba(0,0,0,0.06);
}
.store-title {
   display: flex;
   align-items: center;
   gap: 14px;
}
.store-title h2 {
   margin: 0;
   font-size: 22px;
   color: #1a1a1a;
   font-weight: 700;
}
.store-type-tag {
   display: inline-block;
   padding: 4px 14px;
   background: linear-gradient(135deg, #e57834, #f09a50);
   color: #fff;
   border-radius: 20px;
   font-size: 13px;
   font-weight: 500;
}
.edit-btn {
   display: flex;
   align-items: center;
   gap: 6px;
   padding: 10px 24px;
   background: linear-gradient(135deg, #e57834, #d06520);
   color: #fff;
   text-decoration: none;
   border-radius: 8px;
   font-size: 14px;
   font-weight: 500;
   transition: all 0.3s;
   box-shadow: 0 4px 12px rgba(229,120,52,0.3);
}
.edit-btn:hover {
   background: linear-gradient(135deg, #f08a48, #e57834);
   box-shadow: 0 6px 16px rgba(229,120,52,0.4);
   transform: translateY(-1px);
}
.edit-icon {
   font-size: 16px;
}

/* 信息卡片 */
.info-card {
   background: #fff;
   border-radius: 10px;
   margin-bottom: 20px;
   box-shadow: 0 2px 12px rgba(0,0,0,0.06);
   overflow: hidden;
}
.card-header {
   display: flex;
   align-items: center;
   gap: 10px;
   padding: 16px 28px;
   border-bottom: 1px solid #f0f0f0;
   background: #fafbfc;
}
.card-header h3 {
   margin: 0;
   font-size: 16px;
   color: #333;
   font-weight: 600;
}
.card-icon {
   font-size: 20px;
}
.card-body {
   padding: 24px 28px;
}

/* 信息行 */
.info-row {
   display: flex;
   gap: 40px;
   margin-bottom: 20px;
}
.info-row:last-child {
   margin-bottom: 0;
}
.info-item {
   flex: 1;
   display: flex;
   flex-direction: column;
   gap: 8px;
}
.info-item.full-width {
   flex: none;
   width: 100%;
}
.info-label {
   font-size: 13px;
   color: #999;
   font-weight: 400;
}
.info-value {
   font-size: 15px;
   color: #333;
   font-weight: 500;
   line-height: 1.6;
   word-break: break-all;
}

/* 图片展示 */
.img-value {
   display: flex;
   align-items: center;
}
.img-card {
   width: 160px;
   height: 110px;
   border-radius: 8px;
   overflow: hidden;
   cursor: pointer;
   position: relative;
   border: 1px solid #eaeaea;
   transition: all 0.3s;
   flex-shrink: 0;
}
.img-card.small {
   width: 130px;
   height: 90px;
}
.img-card:hover {
   box-shadow: 0 4px 16px rgba(0,0,0,0.12);
   transform: translateY(-2px);
}
.img-card img {
   width: 100%;
   height: 100%;
   object-fit: cover;
}
.img-overlay {
   position: absolute;
   top: 0;
   left: 0;
   width: 100%;
   height: 100%;
   background: rgba(0,0,0,0.4);
   display: flex;
   align-items: center;
   justify-content: center;
   color: #fff;
   font-size: 13px;
   opacity: 0;
   transition: opacity 0.3s;
}
.img-card:hover .img-overlay {
   opacity: 1;
}
.no-img {
   color: #ccc;
   font-size: 13px;
}
.id-card-row {
   display: flex;
   gap: 24px;
}
.id-card-item {
   display: flex;
   flex-direction: column;
   gap: 8px;
}
.id-card-label {
   font-size: 13px;
   color: #888;
}

/* 详情文本区 */
.detail-row {
   display: flex;
   margin-bottom: 22px;
   padding-bottom: 22px;
   border-bottom: 1px solid #f5f5f5;
}
.detail-row:last-child {
   margin-bottom: 0;
   padding-bottom: 0;
   border-bottom: none;
}
.detail-label {
   width: 90px;
   flex-shrink: 0;
   font-size: 14px;
   color: #999;
   font-weight: 400;
   line-height: 1.8;
}
.detail-content {
   flex: 1;
   font-size: 14px;
   color: #444;
   line-height: 1.8;
   word-break: break-all;
}
.detail-content.rich-text :deep(p) {
   max-width: 100%;
   margin: 0;
}
.detail-content.rich-text :deep(img) {
   max-width: 100%;
   border-radius: 6px;
}

/* 图片全屏预览 */
#showimgbox {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 50;
    top: 0;
    left: 0;
    background-color: rgba(0,0,0,0.7);
}
#showimgbox img {
    position: absolute;
    top: 50%;
    left: 50%;
    border-radius: 6px;
}
#showimgbox a {
    width: auto;
    height: 40px;
    position: absolute;
    top: 10px;
    right: 10px;
    display: block;
    color: #fff;
    text-align: center;
    line-height: 40px;
    text-decoration: none;
    background: rgba(0,0,0,0.4);
    padding: 0 16px;
    border-radius: 20px;
    font-size: 14px;
    transition: background 0.3s;
}
#showimgbox a:hover {
    background: rgba(0,0,0,0.6);
}
</style>